import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const Overview = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Overview.vue')
const Widgets = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Dashboard/Widgets.vue')

// Pages
import User from 'src/components/Dashboard/Views/Pages/UserProfile.vue'
import Ems from 'src/components/Dashboard/Views/Pages/Ems.vue'
import AddUser from 'src/components/Dashboard/Views/Pages/Add-user.vue'
import ViewContract from 'src/components/Dashboard/Views/Pages/ViewContract.vue'
import EditContract from 'src/components/Dashboard/Views/Pages/EditContract.vue'
import Terminal from 'src/components/Dashboard/Views/Pages/Terminal.vue'
import AddTerminal from 'src/components/Dashboard/Views/Pages/Add-terminal.vue'
import TimeLine from 'src/components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from 'src/components/Dashboard/Views/Pages/Login.vue'
import Register from 'src/components/Dashboard/Views/Pages/Register.vue'
import Lock from 'src/components/Dashboard/Views/Pages/Lock.vue'
import RemoteSign from 'src/components/Dashboard/Views/Pages/RemoteSign.vue'

// Components pages
import Buttons from 'src/components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from 'src/components/Dashboard/Views/Components/GridSystem.vue'
import Panels from 'src/components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from 'src/components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from 'src/components/Dashboard/Views/Components/Notifications.vue'
import Icons from 'src/components/Dashboard/Views/Components/Icons.vue'
import Typography from 'src/components/Dashboard/Views/Components/Typography.vue'

// Forms pages
const RegularForms  = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ 'src/components/Dashboard/Views/Forms/Wizard.vue');


const Customers = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/Customers.vue');
const Contracts = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/Contracts.vue');
const Users = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/Users.vue');
const Terminals = () => import(/* webpackChunkName: "tables" */ 'src/components/Dashboard/Views/Tables/Terminals.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ 'src/components/Dashboard/Views/Maps/VectorMapsPage.vue');

// Calendar
import Calendar from 'src/components/Dashboard/Views/Calendar/CalendarRoute.vue'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ 'src/components/Dashboard/Views/Charts.vue')

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ],
  meta: {
    requireAuth: true
  }
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ],
  meta: {
    requireAuth: true
  }
}

let tablesMenu = {
  path: '/search',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'Customers',
      name: 'Customers',
      component: Customers
    },
    {
      path: 'Contracts',
      name: 'Contracts',
      component: Contracts
    },

    {
      path: 'Users',
      name: 'Users',
      component: Users
    },
    {
      path: 'Terminals',
      name: 'Terminals',
      component: Terminals
    }],
  meta: {
    requireAuth: true
  }
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ],
  meta: {
    requireAuth: true
  }
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'terminal',
      name: 'Terminal',
      component: Terminal
    },
    {
      path: 'contract/view',
      name: 'ViewContract',
      component: ViewContract
    },
    {
      path: 'contract/edit',
      name: 'EditContract',
      component: EditContract
    },
    {
      path: 'add-user',
      name: 'Add-user',
      component: AddUser
    },
    {
      path: 'add-terminal',
      name: 'Add-terminal',
      component: AddTerminal
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    },
    {
      path: 'ems',
      name: 'Ems',
      component: Ems
    }
  ],
  meta: {
    requireAuth: true
  }
}

let RSViewPage = {
  path: '/rs',
  component: RemoteSign,
  redirect: '/rspthk/rs',
  children: [
    {
      path: 'rspthk/rs',
      name: 'RemoteSign',
      component: RemoteSign
    }
  ]

}

let contractViewPage = {
    path: '/spv',
    component: ViewContract,
    redirect: '/search/contracts',
    children: [
      {
        path: 'contract/view',
        name: 'ViewContractSp',
        component: ViewContract
      },
      {
        path: 'contract/edit',
        name: 'EditContractSp',
        component: EditContract
      }
    ]

}

let contractEditPage = {
  path: '/spe',
  component: EditContract,
  redirect: '/search/contracts',
  children: [
    {
      path: 'contract/edit',
      name: 'EditContractSp',
      component: EditContract
    }
  ]

}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}

let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  loginPage,
  contractViewPage,
  contractEditPage,
  registerPage,
  lockPage,
    RSViewPage,
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ],
    meta: {
      requireAuth: true
    }
  },
  {path: '*', component: NotFound}
];

export default routes
